import { render, staticRenderFns } from "./CodePostal.vue?vue&type=template&id=5329cc80&scoped=true"
import script from "./CodePostal.vue?vue&type=script&lang=js"
export * from "./CodePostal.vue?vue&type=script&lang=js"
import style0 from "./CodePostal.vue?vue&type=style&index=0&id=5329cc80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5329cc80",
  null
  
)

export default component.exports